import { jsx as s } from "react/jsx-runtime";
import { c as u } from "../clsx-OuTLNxxd.js";
const l = "ButtonsContainer-module_buttons-container__E9eRX",
  p = "ButtonsContainer-module_gap-regular__gd0oz",
  i = "ButtonsContainer-module_gap-compact__HMOgC",
  g = "ButtonsContainer-module_mobile-full-size__MPvcz",
  m = "ButtonsContainer-module_center__yvspM",
  _ = "ButtonsContainer-module_left__lwngV",
  C = "ButtonsContainer-module_right__PBEhy",
  B = "ButtonsContainer-module_spacing-top-regular__H28qC",
  d = "ButtonsContainer-module_spacing-top-compact__h336j",
  b = "ButtonsContainer-module_spacing-bottom-regular__8BFuu",
  f = "ButtonsContainer-module_spacing-bottom-compact__-wifh",
  t = {
    buttonsContainer: l,
    gapRegular: p,
    gapCompact: i,
    mobileFullSize: g,
    center: m,
    left: _,
    right: C,
    spacingTopRegular: B,
    spacingTopCompact: d,
    spacingBottomRegular: b,
    spacingBottomCompact: f
  },
  z = _ref => {
    let {
      children: c,
      spacingTop: n,
      spacingBottom: e,
      mobileFullSize: r = !1,
      align: o = "center",
      gap: a = "regular"
    } = _ref;
    return /* @__PURE__ */s("div", {
      className: u(t.buttonsContainer, {
        [t.gapCompact]: a == "compact",
        [t.gapRegular]: a == "regular",
        [t.left]: o == "left",
        [t.center]: o == "center",
        [t.right]: o == "right",
        [t.spacingTopRegular]: n == "regular",
        [t.spacingTopCompact]: n == "compact",
        [t.spacingBottomRegular]: e == "regular",
        [t.spacingBottomCompact]: e == "compact",
        [t.mobileFullSize]: r
      }),
      children: c
    });
  };
export { z as ButtonsContainer };